import type { TResponseBase } from '../../types'
import UserControllerBase from '../base'
import type { NRequestContactSupport } from './types'

export default class ContactController extends UserControllerBase {
  static readonly controllerPath = 'contact'
  private readonly serviceUrl: string

  constructor() {
    super(ContactController.controllerPath)
    this.serviceUrl = this.getFullServiceUrl()
  }

  async requestContactSupport(
    body: NRequestContactSupport.TBody,
  ): TResponseBase<NRequestContactSupport.TResponseData> {
    return await useFetchInstance(`${this.serviceUrl}/support`, {
      method: 'POST',
      body,
    })
  }
}
